module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_gold.804dabc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_gold.png
// module id = 2095
// module chunks = 0